import { ToastContainer } from 'react-toastify'
import HeaderComponent from './mygame/header/header'
import SubheaderComponent from './mygame/subheader/nav/subheader'
import { useLocation } from 'react-router'
import { ROUTES } from '../../core/routing/router/routes'
import MenuComponent from './mygame/menu/menu'
import { useEffect, useState } from 'react'
import { AnnouncementBanner } from './mygame/announcement/annoucement-banner'
import { useTranslation } from 'react-i18next'

const AppWrapper = ({ children }) => {
  const { t } = useTranslation()
  const [isOpen, setIsOpen] = useState(false)
  const url = useLocation().pathname
  const subheaderProps = ROUTES.find(item => item.path === url)

  useEffect(() => {
    setTimeout(() => {
      setIsOpen(false)
    }, 400)
  }, [url])

  return (
    <div className="mg-app-wrapper">
      <HeaderComponent isOpen={isOpen} setIsOpen={setIsOpen} />
      <AnnouncementBanner />
      <SubheaderComponent
        routeId={subheaderProps?.id}
        title={subheaderProps?.name && t(subheaderProps.name)}
        description={subheaderProps?.description && t(subheaderProps.description)}
        shortcutSportsGroups={subheaderProps?.shortcutSportsGroups}
        shortcutStoresGroups={subheaderProps?.shortcutStoresGroups}
        breadcrumbs={subheaderProps?.breadcrumbs}
        isVisibleSubheader={subheaderProps?.isVisibleSubheader}
      />
      <ToastContainer />
      <MenuComponent isOpen={isOpen} setIsOpen={setIsOpen} url={url} />
      {children}
    </div>
  )
}

export default AppWrapper
